var _path, _path2, _path3, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 1200 1200",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m-3.53-3.53h1207.06v1207.06h-1207.06z",
    fill: "#0f0f0f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m420.31 551.09h65.88l-48.99 168.92h-63.52l-20.95-79.39-20.95 79.39h-63.51l-48.97-168.92h65.88l19.6 93.58 24.33-93.58h47.3l24.33 93.58z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m714.6 512.48-113.01 7.76-15.92-46.32 106.64-26.29zm-179.33 21.76c-10.4 1.06-19.59-1.67-27.59-8.18-7.99-6.52-12.53-14.97-13.59-25.37-1.06-10.39 1.67-19.59 8.18-27.59 6.52-8 14.97-12.52 25.36-13.59 10.4-1.06 19.59 1.66 27.59 8.18 8 6.51 12.53 14.97 13.59 25.37 1.06 10.39-1.66 19.59-8.18 27.59-6.51 8-14.97 12.53-25.36 13.59z",
    fill: "#6050d1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m683.87 546.36c18.47 0 33.28 6.37 44.43 19.09 11.15 12.73 16.72 31.7 16.72 56.93v97.64h-62.5v-90.88c0-15.09-6.98-22.64-20.95-22.64-7.43 0-13.12 2.37-17.06 7.09-3.94 4.73-5.91 11.27-5.91 19.59v86.83h-62.5v-168.92h62.5v16.55c10.36-14.19 25.45-21.28 45.27-21.28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m933.24 720.01h-69.26l-40.54-67.57v67.57h-62.5v-168.92h62.5v65.54l35.47-65.54h70.95l-51.35 84.46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m955.14 697.51v6.24h-5.3v16.27h-6.43v-16.27h-5.3v-6.24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m980.7 697.51v22.5h-6.43v-10.96l-5.01 8.42h-.58l-5.01-8.42v10.96h-6.43v-22.5h6.43l5.3 9.16 5.3-9.16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m497.68 720.37v-168.92h62.5v168.92z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWink);
export default __webpack_public_path__ + "static/media/wink.121482f7971d057116df4173a47e994c.svg";
export { ForwardRef as ReactComponent };